import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from '../../shared/services/api.service';
import {empty} from '../../functions';
import {alertMessages, AlertService} from '../../shared/services/alert.service';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import bsCustomFileInput from 'bs-custom-file-input';

@Component({
    selector: 'app-modal-student-profile-avatar',
    templateUrl: './modal-account-avatar.component.html',
    styleUrls: ['./modal-account-avatar.component.scss'],
    standalone: false
})
export class ModalAccountAvatarComponent implements OnInit {

  // Icons
  faSpinner = faSpinner;

  public isProcessing = false;

  public data:any;

  imageChangedEvent: any = '';
  croppedImage: any = '';

  fileName = '';

  file = '';

  account = {
    id: '',
  };

  /**
   * Constructor
   *
   * @param activeModal
   * @param api
   * @param alertService
   */
  constructor(public activeModal: NgbActiveModal,
              public api: ApiService,
              private alertService: AlertService) {


  }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    bsCustomFileInput.init();

    this.account = this.data;

  }

  /**
   * Event handler when file input changes
   *
   * @param event
   */
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;

    // Search for file name when input file changes
    if (this.imageChangedEvent.target.files && this.imageChangedEvent.target.files.length > 0) {

      for (let i = 0; i < this.imageChangedEvent.target.files.length; i++) {
        const file = this.imageChangedEvent.target.files[i];
        this.fileName = file.name;
      }
    }
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded(image: HTMLImageElement) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  /**
   * Save avatar image
   *
   * @constructor
   */
  Save() {

    this.isProcessing = true;

    if (this.croppedImage && this.fileName) {

      // Create multipart form data of base64 and upload to correct API endpoint
      fetch(this.croppedImage)
        .then(res => res.blob())
        .then(blob => {
          const fd = new FormData();
          const file = new File([blob], this.fileName);
          fd.append('file', file);

          // Finally upload the file
          const API_URL = this.api.getApiUrl() + '/account/' + this.account.id + '/avatar';
          const headers = this.api.getUploadHeaders();
          fetch(API_URL, {method: 'PUT', headers: headers, body: fd})
            .then((res) => {

              this.isProcessing = false;

              if (res.status == 200) {
                this.activeModal.close(true);
              } else {
                // Some error
              }


            }).catch( (error) => {
            this.isProcessing = false;
          })

        });

    }
  }

}
